// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2R2nA","description":"PatientConsentPreview_description__3UoqK"};